import styled from 'styled-components';
import { minBp } from 'src/lib/theme';

const DummyHeader = styled.header`
  background-color: black;
  height: 60px;

  @media ${minBp('tabletLarge')} {
    height: 80px;
  }

  @media (min-width: 1366px) {
    height: 70px;
  }
`;

export default DummyHeader;
